import React from 'react';
import { Plus } from 'lucide-react';
import KanbanCard from './KanbanCard';

const KanbanColumn = ({ column, tasks, onEdit, onAddTask, onDragStart, onDragOver, onDrop }) => {
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    onDrop(column.id, null);
  };

  return (
    <div className="flex-shrink-0 w-[380px]">
      {/* Column Header with Color Badge */}
      <div className="bg-column-header rounded-t-xl px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {/* Color Badge */}
          <div 
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: column.color || '#6b7280' }}
          ></div>
          <h2 className="text-white text-sm font-bold uppercase tracking-wide">{column.title}</h2>
        </div>
        <span className="text-white text-sm font-bold bg-column-badge px-2 py-0.5 rounded-full">{tasks.length}</span>
      </div>

      {/* Droppable Area with gray rounded background and scroll */}
      <div 
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        className="bg-column rounded-b-xl p-3 min-h-[600px] max-h-[calc(100vh-200px)] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent"
      >
        {tasks.map((task, index) => (
          <KanbanCard 
            key={task.id} 
            task={task} 
            onEdit={onEdit}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDrop={onDrop}
          />
        ))}

        {/* Add Task Button */}
        <button
          onClick={() => onAddTask(column.id)}
          className="w-full flex items-center justify-center gap-2 py-3 text-gray-400 hover:text-white hover:bg-column-badge rounded-lg transition-colors text-sm mt-2"
        >
          <Plus className="w-4 h-4" />
          <span>Ajouter une tâche</span>
        </button>
      </div>
    </div>
  );
};

export default KanbanColumn;
